module.exports = __webpack_public_path__ + "static/media/document-safes.49cf2a14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/hero/document-safes.jpg
// module id = 1244
// module chunks = 0